import React from "react";

interface OnlineStatusBadgeProps {
    status?: "online" | "away" | "busy" | "offline";
    size?: number;     // dot size
    color?: string;    // main color you pass in
}

export default function OnlineStatusBadge({
    status = "online",
    size = 10,
    color,
}: OnlineStatusBadgeProps) {
    // default colors if user does not pass one
    const defaultColors: Record<string, string> = {
        online: "#22c55e",   // green
        away: "#facc15",     // yellow
        busy: "#ef4444",     // red
        offline: "#9ca3af",  // gray
    };

    const dotColor = color || defaultColors[status];
    const dotSize = `${size}px`;

    return (
        <div style={{ display: "flex", alignItems: "center", gap: "8px", userSelect: "none" }}>
            {/* Status container */}
            <div
                style={{
                    position: "relative",
                    width: size * 2.6,
                    height: size * 2.6,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                {/* Ripple animation */}
                <span
                    style={{
                        position: "absolute",
                        borderRadius: "50%",
                        width: size * 2.6,
                        height: size * 2.6,
                        backgroundColor: dotColor,
                        opacity: 0.4,
                        animation: "ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite",
                    }}
                />

                {/* Solid dot */}
                <span
                    style={{
                        position: "relative",
                        borderRadius: "50%",
                        width: dotSize,
                        height: dotSize,
                        backgroundColor: dotColor,
                        boxShadow: "0 0 0 2px rgba(255,255,255,0.03)",
                    }}
                />
            </div>

            {/* Status text */}
            <span style={{ fontSize: "14px", fontWeight: 500, color: "white" }}>
                {status.charAt(0).toUpperCase() + status.slice(1)}
            </span>

            {/* Keyframes for ripple */}
            <style>{`
        @keyframes ping {
          75%, 100% {
            transform: scale(2);
            opacity: 0;
          }
        }
      `}</style>
        </div>
    );
}
